import { useCallback, useEffect, useState } from "react";

import Button from "@covertree/ui/buttons/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

interface Props {
  onResendCode: () => void;
}

export const ResendCodeButton = ({ onResendCode }: Props) => {
  const [disabled, setDisabled] = useState(false);

  const handleResendCode = useCallback(async () => {
    await onResendCode();

    setDisabled(true);
  }, [onResendCode, setDisabled]);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (disabled) {
      timer = setTimeout(() => {
        setDisabled(false);
      }, 60_000);
    }

    return () => clearTimeout(timer);
  }, [disabled, setDisabled]);

  return (
    <Grid item xs={12}>
      <Box mt={4}>
        <Button
          data-testid="resend-code-button"
          fullWidth
          variant="text"
          disabled={disabled}
          onClick={handleResendCode}>
          Resend the code
        </Button>
      </Box>
    </Grid>
  );
};

export default ResendCodeButton;
